import { httpRequest } from "../../http";
import type { MissingMembers } from "@models/Discrepancy.model";

export class CommandGetMissingMembers {
  async run(id: number): Promise<MissingMembers> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${id}/missing-members/`;
    return httpRequest<MissingMembers>(url, { method: "GET" });
  }
}
